export default __webpack_public_path__ + "static/media/61_desktop.e92ee092.jpg";